import React from 'react';
import HomePage from './HomePage/HomePage';
import ExplorePage from './ExplorePage/ExplorePage'; 
import AboutUs from './AboutUs/AboutUs';
import WhyChooseUs from './WhyChooseUs/WhyChooseUs';
import HappyCustomers from './HappyCustomer/HappyCustomers';
import FAQs from './FAQs/FAQs';
import GetStarted from './GetStarted/GetStarted';

const StockportContainer = () => {
    return (
        <>
            <HomePage />
            <ExplorePage /> 
            <AboutUs />
            <WhyChooseUs /> 
            <HappyCustomers />
            <FAQs />
            <GetStarted />
        </>
    )
}

export default StockportContainer;